<se-fe-chip-group class="open-registration-filter">
  <se-fe-chip
    [seFeDataText]="sportChipText | translate"
    seFeDataIconRight="chevron_down"
    [seFeDataSelected]="hasSelectedValues(selectedSportIds)"
    [seFeDataDisabled]="sportFilterDisabled"
    [seFeMenuTrigger]="sportFilterDisabled ? null : sportMenu">
    @if (selectedSportIds.length) {
      <se-fe-indicator-dot
        seFeChipIndicatorDot
        [seFeDataValue]="selectedSportIds.length">
      </se-fe-indicator-dot>
    }
  </se-fe-chip>

  <se-fe-chip
    [seFeDataText]="organizationChipText | translate"
    seFeDataIconRight="chevron_down"
    [seFeDataSelected]="hasSelectedValues(selectedOrganizationIds)"
    [seFeDataDisabled]="organizationFilterDisabled"
    [seFeMenuTrigger]="organizationFilterDisabled ? null : organizationMenu">
    @if (selectedOrganizationIds.length) {
      <se-fe-indicator-dot
        seFeChipIndicatorDot
        [seFeDataValue]="selectedOrganizationIds.length">
      </se-fe-indicator-dot>
    }
  </se-fe-chip>

  <se-fe-chip
    [seFeDataText]="typeChipText | translate"
    seFeDataIconRight="chevron_down"
    [seFeDataSelected]="hasSelectedValues(selectedTypeIds)"
    [seFeDataDisabled]="typeFilterDisabled"
    [seFeMenuTrigger]="typeFilterDisabled ? null : typeMenu">
    @if (selectedTypeIds.length) {
      <se-fe-indicator-dot
        seFeChipIndicatorDot
        [seFeDataValue]="selectedTypeIds.length">
      </se-fe-indicator-dot>
    }
  </se-fe-chip>
</se-fe-chip-group>

<se-fe-menu-filter #sportMenu [seFeDataOptions]="sportMenuOptions">
  <div seFeMenuContent class="open-registration-filter__menu-content">
    <form [formGroup]="filtersForm" novalidate>
      <se-fe-list formGroupName="sport" [seFeDataDividers]="false">
        @for (sport of sports; track sport.id) {
        <se-fe-list-item class="open-registration-filter__checkbox-row">
          <se-fe-checkbox
            [formControlName]="sport.id"
            [seFeDataOptions]="sportCheckboxOptions[sport.id]">
          </se-fe-checkbox>
        </se-fe-list-item>
        }
      </se-fe-list>
    </form>
  </div>
  <se-fe-button-group
    seFeMenuFooter
    class="open-registration-filter__menu-actions"
    [seFeDataFullWidth]="true"
    [seFeDataStacked]="true">
    <se-fe-button
      seFeDataEmphasis="high"
      [seFeDataFullWidth]="true"
      (click)="applyFilter('sport', sportMenu)">
      {{ translationKey + 'FILTER.apply_filters' | translate }}
    </se-fe-button>
    <se-fe-button
      [seFeDataFullWidth]="true"
      (click)="clearFilter('sport', sportMenu)">
      {{ translationKey + 'FILTER.clear_all_filters' | translate }}
    </se-fe-button>
  </se-fe-button-group>
</se-fe-menu-filter>

<se-fe-menu-filter #organizationMenu [seFeDataOptions]="organizationMenuOptions">
  <div seFeMenuContent class="open-registration-filter__menu-content">
    <form [formGroup]="filtersForm" novalidate>
      <se-fe-list formGroupName="organization" [seFeDataDividers]="false">
        @for (organization of organizations; track organization.id) {
        <se-fe-list-item class="open-registration-filter__checkbox-row">
          <se-fe-checkbox
            [formControlName]="organization.id"
            [seFeDataOptions]="organizationCheckboxOptions[organization.id]">
          </se-fe-checkbox>
        </se-fe-list-item>
        }
      </se-fe-list>
    </form>
  </div>
  <se-fe-button-group
    seFeMenuFooter
    class="open-registration-filter__menu-actions"
    [seFeDataFullWidth]="true"
    [seFeDataStacked]="true">
    <se-fe-button
      seFeDataEmphasis="high"
      [seFeDataFullWidth]="true"
      (click)="applyFilter('organization', organizationMenu)">
      {{ translationKey + 'FILTER.apply_filters' | translate }}
    </se-fe-button>
    <se-fe-button
      [seFeDataFullWidth]="true"
      (click)="clearFilter('organization', organizationMenu)">
      {{ translationKey + 'FILTER.clear_all_filters' | translate }}
    </se-fe-button>
  </se-fe-button-group>
</se-fe-menu-filter>

<se-fe-menu-filter #typeMenu [seFeDataOptions]="typeMenuOptions">
  <div seFeMenuContent class="open-registration-filter__menu-content">
    <form [formGroup]="filtersForm" novalidate>
      <se-fe-list formGroupName="type" [seFeDataDividers]="false">
        @for (type of signupTypeList; track type.id) {
        <se-fe-list-item class="open-registration-filter__checkbox-row">
          <se-fe-checkbox
            [formControlName]="type.id"
            [seFeDataOptions]="typeCheckboxOptions[type.id]">
          </se-fe-checkbox>
        </se-fe-list-item>
        }
      </se-fe-list>
    </form>
  </div>
  <se-fe-button-group
    seFeMenuFooter
    class="open-registration-filter__menu-actions"
    [seFeDataFullWidth]="true"
    [seFeDataStacked]="true">
    <se-fe-button
      seFeDataEmphasis="high"
      [seFeDataFullWidth]="true"
      (click)="applyFilter('type', typeMenu)">
      {{ translationKey + 'FILTER.apply_filters' | translate }}
    </se-fe-button>
    <se-fe-button
      [seFeDataFullWidth]="true"
      (click)="clearFilter('type', typeMenu)">
      {{ translationKey + 'FILTER.clear_all_filters' | translate }}
    </se-fe-button>
  </se-fe-button-group>
</se-fe-menu-filter>
